import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import HCLTreeMxGraphView from "../MxGraphViews/HCLTreeMxGraphView";
import {Error} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import HclApiManager from "../../../../../Api/HclApiManager";
import CircularIndeterminate
  from "hcla-web-frontend-primitives/app/components/primitives/Progress/CircularIndeterminate";

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
    position: 'relative'
  },
  icon: {
    width: '16rem',
    height: '16rem',
    margin: 'auto',
    color: theme.palette.text.secondary,
  },

});

const TreeSnapshotView = (props) => {
  const { classes, treeId } = props;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!!treeId);

  useEffect(() => {
    if (!data) {
      HclApiManager.getHclTreeWithMetadata(treeId)
        .then((response) => response.ok && response.json())
        .then((data) => setData(data));
    }
  }, [treeId]);

  useEffect(() => {
    if (data) {
      setLoading(false);
    }
  },[data])
  return (
    <div className={classes.root}>
        {
          loading
          ? (
              <CircularIndeterminate />
            )
          : !loading && data
          ? (
              <HCLTreeMxGraphView data={data} />
            )
          : (
              <React.Fragment>
                <Error className={classes.icon} />
                <Typography variant="h2" align="center" color="textSecondary" paragraph>
                  Snapshot not available
                </Typography>
              </React.Fragment>
            )
        }
    </div>
  );
};

TreeSnapshotView.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  depth: PropTypes.number.isRequired,
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
    path: PropTypes.string,
  }).isRequired,
};

export default withStyles(styles)(TreeSnapshotView);
